import { PageWithRightPane } from "../../frameworks/joy/layouts/page_with_right_pane";
import { CustomersContainer } from "./container";

export const CustomersPage = () => {
  return (
    <PageWithRightPane>
      <CustomersContainer />
    </PageWithRightPane>
  );
};
